import { Star, Sparkles, Gift } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const TIERS = [
  { name: "Bronze Citizen", min: 0, color: "#CD7F32", perks: ["Earn 1pt / $1", "Birthday treat"] },
  { name: "Silver Noble", min: 500, color: "#C0C0C0", perks: ["1.25x points", "Exclusive deals", "Free Halo-Halo on birthday"] },
  { name: "Gold Royalty", min: 1500, color: "#D4AF37", perks: ["1.5x points", "Priority pickup", "Free delivery (5mi)"] },
  { name: "Maharlika Elite", min: 5000, color: "#0F3D81", perks: ["2x points", "VIP lechon access", "Catering discount 10%", "Members-only events"] },
];

export default function Rewards() {
  const { user } = useAuth();
  return (
    <div className="chow-theme bg-[#050505] text-[#FAF9F6] min-h-screen" data-testid="rewards-page">
      <section className="border-b border-[#D4AF37]/30 py-14 text-center">
        <BrandLogo type="rewards" size="xl" showText={false} className="justify-center" />
        <span className="font-accent text-xs text-[#D4AF37] mt-2 block">ROYAL REWARDS</span>
        <h1 className="font-heading text-5xl mt-2">A Loyalty Program <span className="italic text-[#D4AF37]">Fit for Royalty</span></h1>
        <p className="text-[#FAF9F6]/60 max-w-xl mx-auto mt-3">Earn points with every order. Climb the tiers. Unlock exclusive Filipino feasts.</p>
        {user ? (
          <div className="mt-8 inline-block chow-card px-8 py-5">
            <div className="font-accent text-xs text-[#D4AF37]">YOUR BALANCE</div>
            <div className="font-heading text-5xl text-[#D4AF37] mt-1">{user.points || 0} <span className="text-base">points</span></div>
            <div className="text-xs text-[#FAF9F6]/60 mt-1">Tier: {user.tier || "Bronze Citizen"}</div>
          </div>
        ) : (
          <Link to="/register" className="btn-chow inline-block mt-6">Join Rewards</Link>
        )}
      </section>

      <div className="max-w-6xl mx-auto px-4 lg:px-8 py-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {TIERS.map((t) => (
          <div key={t.name} className="chow-card p-6" data-testid={`tier-${t.name.toLowerCase().replace(/\s/g, '-')}`}>
            <Star className="w-7 h-7 mb-3" style={{ color: t.color }} fill={t.color} strokeWidth={1}/>
            <div className="font-heading text-2xl" style={{ color: t.color }}>{t.name}</div>
            <div className="text-xs text-[#FAF9F6]/60 mb-4">{t.min}+ points</div>
            <ul className="space-y-2 text-sm text-[#FAF9F6]/80">
              {t.perks.map((p, i) => <li key={i} className="flex gap-2"><Sparkles className="w-3.5 h-3.5 text-[#D4AF37] mt-0.5"/>{p}</li>)}
            </ul>
          </div>
        ))}
      </div>

      <section className="bg-[#0A1D42] py-12">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <Gift className="w-9 h-9 text-[#D4AF37] mx-auto mb-3"/>
          <h3 className="font-heading text-3xl text-[#D4AF37]">Birthday Treats</h3>
          <p className="text-[#FAF9F6]/70 max-w-xl mx-auto mt-2">Every member receives a complimentary Filipino dessert on their birthday. Because no royalty celebrates alone.</p>
        </div>
      </section>
    </div>
  );
}
